import { Component, input, OnInit, output, inject } from '@angular/core';
import { FormControl } from '@angular/forms';

import { ApContentService } from '@ap/content';

import content from './conversational-chat-input.content.json';

@Component({
    selector: 'conversational-chat-input',
    templateUrl: './conversational-chat-input.component.html',
    standalone: false
})
export class ConversationalChatInputComponent implements OnInit {
    private readonly contentService = inject(ApContentService);

    public inputFieldControl: FormControl<string>;
    public hideSafetyNotification = input<boolean>();
    public sendMessage = output<string>();
    public firstMessageSent = output<boolean>();

    public ngOnInit(): void {
        this.contentService.addContentItems(content);
        this.inputFieldControl = new FormControl(null);
    }

    public onSendChatMessage(): void {
        if (this.inputFieldControl.value && this.inputFieldControl.value?.trim()) {
            this.sendMessage.emit(this.inputFieldControl.value);
            this.inputFieldControl.setValue('');
            this.firstMessageSent.emit(true);
        }
    }
}
